﻿import React from 'react';
import Lottie from 'lottie-react';
import useIntersection from '../useIntersection';

import mobilePhoneAnimData from '../../../../AnimationFiles/mobile-phone.json';

const MobilePhoneAnimation = () => {

    const ref = React.useRef();
    const lottieRef = React.useRef();
    const inViewport = useIntersection(ref, "-50px");

    React.useEffect(() => {
        if (inViewport === true) {
            if (lottieRef && lottieRef.current) {
                lottieRef.current.play();
            }
        } else {
            if (lottieRef && lottieRef.current) {
                lottieRef.current.pause();
            }
        }
    }, [ref, inViewport])

    return (
        <div ref={ref}>
             <Lottie
                className="school-directors-campaign__mobile-phone__animation"
                autoplay={false}
                loop={true}
                animationData={mobilePhoneAnimData}
                lottieRef={lottieRef}
            />
        </div>
     )
 }                

export default MobilePhoneAnimation;